import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';
import styles from './animate-crossfade.styl';


export default class AnimateCrossfade extends React.Component {
  static propTypes = {
    children: React.PropTypes.any,
    currentIdIndex: React.PropTypes.number,
  };

  static defaultProps = {
    children: [],
    currentIdIndex: 0,
  };

  state = {
    nextIndex: 0,
    children: [],
  };

  componentWillMount() {
    this.handlePropsUpdate(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.handlePropsUpdate(nextProps);
  }

  handlePropsUpdate({ currentIdIndex }) {
    this.prevIndex = this.props.currentIdIndex;
    const { children } = this.props;
    // Because of canShowChannelCover stuff
    setTimeout(() => {
      this.setState({
        children,
        nextIndex: currentIdIndex,
      });
    });
  }

  prevIndex = null;

  isActive(slideIndex) {
    return slideIndex === this.state.nextIndex;
  }

  isPrevActive(slideIndex) {
    return slideIndex === this.prevIndex;
  }

  @autobind
  handleTransitionEnd() {
    // Because of canShowChannelCover stuff
    this.setState({
      children: this.props.children,
    });
  }

  @autobind
  renderWrappedSlide(slide, slideIndex) {
    const className = classnames(
      styles.slide, {
        [styles.active]: this.isActive(slideIndex),
        [styles.prevActive]: this.isPrevActive(slideIndex),
      }
    );

    return (
      <div className={className}
           onTransitionEnd={this.handleTransitionEnd}
           key={slideIndex}>
        {slide}
      </div>
    );
  }

  render() {
    return (
      <div className={styles.container}>
        {_.map(this.state.children, this.renderWrappedSlide)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/animate-crossfade/animate-crossfade.js